export default __webpack_public_path__ + "static/media/logo-mini.25ca56f9.svg";